module.exports = __webpack_public_path__ + "static/media/coding20.5afb17ba.jpg";